<template>
  <layout-default>
    <div class="home-page">
      <section class="hero-section">
        <div class="carousel">
          <!-- La transizione avvolge correttamente l'intero div della slide -->
          <transition name="fade" mode="out-in">
            <div
              class="carousel-slide"
              :key="heroSlides[currentSlide]?.id || currentSlide" 
              :style="{ backgroundImage: `url(${heroSlides[currentSlide]?.image})` }"
            >
              <div class="hero-overlay"></div>
              <div class="hero-inner">
                <div class="hero-text">
                  <!-- Mostra il titolo della slide corrente -->
                  <h1>{{ heroSlides[currentSlide]?.title || "" }}</h1>
                  <!-- Mostra il sottotitolo della slide corrente -->
                  <h1>{{ heroSlides[currentSlide]?.subtitle || "" }}</h1>
                </div>
                <div class="hero-cta">
                  <!-- Mostra l'autore della slide corrente -->
                  <p class="hero-subtitle">{{ heroSlides[currentSlide]?.author || "" }}</p>
                  <!-- Usa il link della slide corrente, con fallback a /shop -->
                  <router-link
                    :to="heroSlides[currentSlide]?.link || '/shop'"
                    class="hero-link"
                  >
                    Go to the Shop >>
                  </router-link>
                </div>
              </div>
            </div>
          </transition>
          <button
            class="carousel-btn prev-btn"
            @click="prevSlide"
            aria-label="Previous slide"
          >
            &#9664;
          </button>
          <button
            class="carousel-btn next-btn"
            @click="nextSlide"
            aria-label="Next slide"
          >
            &#9654;
          </button>
        </div>
      </section>
      <section class="features-section">
        <div class="features-card">
          <SectionFeatures />
        </div>
      </section>
      <section class="home-section latest-products-section">
        <SectionLatestAuctions />
      </section>
      <!-- Vendors -->
      <section class="home-section vendors-section">
        <Heading title="Master Craftsmen" />
        <div class="vendors-grid">
          <router-link
            v-for="(vendor, index) in displayVendors"
            :key="vendor.id || vendor.containerPath || index"
            class="vendor-item"
            :class="'vendor-' + (index + 1)"
            :style="{ backgroundImage: getVendorBackground(vendor) }"
            :to="getVendorRoute(vendor)"
          >
            <div class="vendor-overlay">
              <h3 class="vendor-name">{{ vendor.name }}</h3>
            </div>
          </router-link>
        </div>
        <router-link to="/vendors" class="view-vendors-btn">View all Master Craftsmen</router-link>
      </section>
      <section class="home-section products-section" v-if="categories.length">
        <Heading title="Products" />
        <div class="product-tabs">
          <button
            v-for="(cat, index) in categories"
            :key="cat._id || index"
            type="button"
            class="product-tab"
            :class="{ active: selectedCategoryIndex === index }"
            @click="selectCategory(index)"
          >
            {{ cat.nome }}
          </button>
        </div>
        <div class="category-grid">
          <SectionLatestAuctionsWithCategoryName
            v-if="selectedCategory"
            :key="selectedCategory._id"
            :title="selectedCategory.nome"
            :productsNo="selectedCategory?.totArticles || 0"
            :skipAuctions="0"
            :categoryId="selectedCategory._id"
            :background="categoryBackground"
          />
        </div>
      </section>
      <section class="home-section contact-section">
        <SectionContact />
      </section>
      <section class="home-section brands-section">
        <SectionBrands />
      </section>
    </div>
  </layout-default>
</template>

<script>
import SectionLatestAuctions from "../../components/organisms/Section/SectionLatestAuctions.vue";
import SectionLatestAuctionsWithCategoryName from "../../components/organisms/Section/SectionLatestAuctionsWithCategoryName.vue";
import SectionFeatures from "../../components/organisms/Section/SectionFeatures.vue";
import SectionContact from "../../components/organisms/Section/Contact/SectionContact1.vue";
import SectionBrands from "../../components/organisms/Section/SectionBrands.vue";
import LayoutDefault from "../../components/organisms/LayoutDefault/LayoutDefault.vue";
import Heading from "../../components/atoms/SectionHeading/Heading.vue";
import { getProductCategories } from "../../services/productService";
import { fetchVendors } from "../../composables/manageVendors";
import { NO_USER } from "../../constents/app"; // Assicurati che il percorso sia corretto
import { getVendorRoute } from "../../utils/vendorRoute";

export default {
  name: "Home",
  beforeCreate() {
    document.title = "Viabrera";
  },
  components: {
    SectionLatestAuctions,
    SectionLatestAuctionsWithCategoryName,
    SectionFeatures,
    SectionContact,
    SectionBrands,
    LayoutDefault,
    Heading,
  },
  data() {
    return {
      categories: [],
      categoriesBackground: [
        "radial-gradient(#ff5f4a,#dd3e29)",
        "radial-gradient(#fce406,#f9be00)",
        "radial-gradient(#47e2e4,#0fb4b6)",
        "radial-gradient(#c26bf3,#925bd6)",
        "radial-gradient(#7bde8e,#32b35c)",
        "radial-gradient(#f78ca0,#f9748f)",
      ],
      selectedCategoryIndex: 0,
      currentSlide: 0,
      // --- MODIFICA: Rimpiazza l'array 'slides' con 'heroSlides' ---
      // slides: [
      //   require("@/assets/images/hero-section/slider1.png"),
      //   require("@/assets/images/hero-section/slider2.webp"),
      //   require("@/assets/images/hero-section/slider3.jpg"),
      // ],
      heroSlides: [
        {
          id: 1, // Aggiunto ID univoco per la transizione
          image: require("@/assets/images/hero-section/slider1.jpg"),
          title: "Refined Masterpieces",
          subtitle: "Beauty ad timeless Design",
          author: "Fonderia del giudice",
          link: "/shop" // Link opzionale per la slide
        },
        {
          id: 2,
          image: require("@/assets/images/hero-section/slider2.jpg"),
          title: "Refined Masterpieces", // Testo personalizzato per la slide 2
          subtitle: "Beauty ad timeless Design",
          author: "Bianco Bianchi",
          link: "/shop" // Link specifico per slide 2 (opzionale)
        },
        {
          id: 3,
          image: require("@/assets/images/hero-section/slider3.jpg"),
          title: "Refined Masterpieces", // Testo personalizzato per la slide 3
          subtitle: "Beauty ad timeless Design",
          author: "Vanessa Cavallaro",
          link: "/shop" // Link specifico per slide 3 (opzionale)
        },
        {
          id: 4,
          image: require("@/assets/images/hero-section/slider4.jpg"),
          title: "Refined Masterpieces", // Testo personalizzato per la slide 3
          subtitle: "Beauty ad timeless Design",
          author: "Vivan Saskia Wittmer",
          link: "/shop" // Link specifico per slide 3 (opzionale)
        },
        {
          id: 5,
          image: require("@/assets/images/hero-section/slider5.jpg"),
          title: "Refined Masterpieces", // Testo personalizzato per la slide 3
          subtitle: "Beauty ad timeless Design",
          author: "Pino Grasso Ricami",
          link: "/shop" // Link specifico per slide 3 (opzionale)
        },
        // Puoi aggiungere altre slide qui
      ],
      // --- FINE MODIFICA ---
      autoSlideInterval: null,
      vendors: [],
      searchTerm: "",
    };
  },
  computed: {
    selectedCategory() {
      return this.categories[this.selectedCategoryIndex] || null;
    },
    categoryBackground() {
      if (!this.categoriesBackground.length) {
        return "radial-gradient(#000000,#2c2c2c)";
      }
      return this.categoriesBackground[
        this.selectedCategoryIndex % this.categoriesBackground.length
      ];
    },
    displayVendors() {
      if (!Array.isArray(this.vendors)) {
        return [];
      }
      return this.vendors.slice(0, 4);
    },
  },
  created() {
    this.fetchCategories();
    this.fetchHomepageVendors();
    this.startAutoSlide();
  },
  beforeUnmount() {
    clearInterval(this.autoSlideInterval);
  },
  methods: {
    getVendorRoute,
    async fetchCategories() {
      try {
        const response = await getProductCategories({ limit: "6", page: "1" });
        const fetchedCategories = Array.isArray(response.categorie)
          ? response.categorie
          : [];
        if (!fetchedCategories.length) {
          this.categories = [];
          return;
        }
        const totalArticles = fetchedCategories.reduce(
          (sum, category) => sum + Number(category?.totArticles || 0),
          0
        );
        this.categories = [
          {
            _id: null,
            nome: "All",
            totArticles: totalArticles,
          },
          ...fetchedCategories,
        ];
        this.selectedCategoryIndex = 0;
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    },
    async fetchHomepageVendors() {
      try {
        const vendorList = await fetchVendors();
        this.vendors = Array.isArray(vendorList) ? vendorList : [];
      } catch (error) {
        console.error("Error fetching vendors:", error);
        this.vendors = [];
      }
    },
    async logout() {
      localStorage.removeItem('userToken');
      localStorage.removeItem('carrelloId');
      this.$store.commit('resetCart');
      this.$store.commit('wishlist/resetWishlist');
      this.$store.dispatch("user/updateLoggedInUserType", NO_USER);
      if (this.$root.guestUserLogin) {
        await this.$root.guestUserLogin();
      }
      this.$router.push({ name: "MyAccount" });
    },
    // --- MODIFICA: Aggiorna i metodi per usare heroSlides.length ---
    prevSlide() {
      if (this.heroSlides.length > 0) {
         this.currentSlide = (this.currentSlide - 1 + this.heroSlides.length) % this.heroSlides.length;
      } else {
         this.currentSlide = 0;
      }
    },
    nextSlide() {
       if (this.heroSlides.length > 0) {
        this.currentSlide = (this.currentSlide + 1) % this.heroSlides.length;
      } else {
         this.currentSlide = 0;
      }
    },
    // --- FINE MODIFICA ---
    startAutoSlide() {
      this.autoSlideInterval = setInterval(() => {
        this.nextSlide();
      }, 5000); // Cambia slide ogni 5 secondi
    },
    selectCategory(index) {
      this.selectedCategoryIndex = index;
    },
    getVendorBackground(vendor) {
      if (!vendor) {
        return "none";
      }
      const source =
        vendor.gallery?.[0] ||
        vendor.image ||
        vendor.immagine?.path ||
        vendor.immagine ||
        "";
      if (!source) {
        return "none";
      }
      if (/^https?:\/\//i.test(source)) {
        return `url(${source})`;
      }
      const resolved = this.$getFileSource ? this.$getFileSource(source) : source;
      return resolved ? `url(${resolved})` : "none";
    },
    goToSearch() {
      const query = this.searchTerm.trim();
      if (query) {
        this.$router.push({ path: "/shop", query: { search: query } });
      } else {
        this.$router.push({ path: "/shop" });
      }
    },
  },
};
</script>

<style scoped>
/* Lo stile rimane invariato */
.home-page {
  background-color: #ffffff;
  overflow: hidden;
}
/* Hero */
.hero-section {
  position: relative;
  width: 100%;
  min-height: clamp(520px, 70vh, 680px);
  background-color: #000;
  overflow: hidden;
}
.carousel {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: inherit;
}
.carousel-slide {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: inherit;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: stretch;
  justify-content: center;
}
.hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0.9) 0%,
    rgba(0, 0, 0, 0.4) 50%,
    rgba(0, 0, 0, 0.15) 100%
  );
}
.hero-inner {
  position: relative;
  z-index: 1;
  width: min(1200px, 92vw);
  margin: 0 auto;
  padding: clamp(3rem, 6vw, 6rem) clamp(2rem, 5vw, 5rem);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: clamp(2rem, 4vw, 6rem);
  box-sizing: border-box;
}
.hero-text {
  color: #ffffff;
  max-width: 560px;
}
.hero-text h1 {
  font-size: clamp(2.6rem, 4.5vw, 4.5rem);
  font-weight: 700;
  line-height: 1.1;
  margin: 0 0 0.4rem;
}
.hero-text h1:last-of-type {
  margin-bottom: 0;
}
.hero-cta {
  color: #f2f2f2;
  text-align: right;
  margin-left: auto;
  font-size: 1.1rem;
  letter-spacing: 0.02em;
  align-self: flex-end;
}
.hero-subtitle {
  margin: 0;
  font-weight: 500;
}
.hero-link {
  color: #ffffff;
  font-weight: 600;
  font-size: 1.2rem;
  text-decoration: none;
  display: inline-block;
  margin-top: 14px;
  border-bottom: 2px solid transparent;
  transition: transform 0.3s ease, border-color 0.3s ease;
}
.hero-link:hover {
  transform: translateY(4px);
  border-color: rgba(255, 255, 255, 0.85);
}
.carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.9);
  border: none;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  color: #111;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
  transition: background 0.3s ease, transform 0.3s ease;
  z-index: 5;
}
.carousel-btn:hover {
  background: #ffffff;
  transform: translateY(-50%) scale(1.05);
}
.prev-btn {
  left: clamp(1.5rem, 3vw, 3rem);
}
.next-btn {
  right: clamp(1.5rem, 3vw, 3rem);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
/* ... (il resto dello stile rimane invariato) ... */
/* Features */
.features-section {
  margin-top: 30px;
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
}
.features-card {
  background: #ffffff;
  border-radius: 28px;
  width: min(1100px, 92vw);
}
.features-card :deep(.features-container) {
  padding: 0 !important;
}
.features-card :deep(.row) {
  align-items: stretch;
}
.features-card :deep(.feature) {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  padding: 12px 18px;
  margin: 0;
  min-height: 120px;
}
.features-card :deep(.row > div:last-child .feature) {
  border-right: none;
}
.features-card :deep(.feature img) {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #f5f5f5;
  padding: 12px;
  object-fit: contain;
}
.features-card :deep(.feature-text h5) {
  margin: 0 0 6px;
  font-size: 1.1rem;
  font-weight: 600;
}
.features-card :deep(.feature-text p) {
  margin: 0;
  font-size: 0.95rem;
  color: #5a5a5a;
}
/* Shared section spacing */
.home-section {
  width: min(1200px, 92vw);
  margin: 0 auto 110px;
}
.home-section :deep(.svg-border) {
  margin-bottom: 40px;
}
.home-section :deep(.svg-line) {
  background-color: #111;
}
.latest-products-section :deep(.product-carousel-container) {
  margin-top: 20px;
}
/* Vendors */
.vendors-section {
  text-align: center;
}
.vendors-grid {
  margin: 40px 0 50px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-areas:
    "v1 v2"
    "v3 v2"
    "v3 v4";
  grid-auto-rows: minmax(180px, auto);
  gap: 18px;
}
.vendor-item {
  position: relative;
  display: flex;
  min-height: 220px;
  background-size: cover;
  background-position: center;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.2);
  color: inherit;
  text-decoration: none;
  isolation: isolate;
  transition: transform 0.4s ease, box-shadow 0.4s ease;
}
.vendor-item:hover {
  transform: translateY(-6px);
  box-shadow: 0 28px 58px rgba(0, 0, 0, 0.26);
}
.vendor-1,
.vendor-2,
.vendor-3,
.vendor-4 {
  grid-row: auto;
  grid-column: auto;
  align-self: stretch;
}
.vendor-1 {
  grid-area: v1;
}
.vendor-2 {
  grid-area: v2;
  min-height: 440px;
}
.vendor-3 {
  grid-area: v3;
  min-height: 360px;
}
.vendor-4 {
  grid-area: v4;
  min-height: 220px;
}
.vendor-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    185deg,
    rgba(0, 0, 0, 0.05) 30%,
    rgba(0, 0, 0, 0.8) 100%
  );
  display: flex;
  align-items: flex-end;
  padding: 26px 28px 32px;
}
.vendor-name {
  margin: 0;
  color: #ffffff;
  font-size: clamp(1.2rem, 2.4vw, 1.9rem);
  font-weight: 600;
  letter-spacing: 0.01em;
  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.6);
  position: relative;
  padding-bottom: 14px;
  text-align: left;
}
.vendor-name::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: min(120px, 60%);
  height: 3px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 999px;
}
.view-vendors-btn {
  display: inline-block;
  padding: 12px 32px;
  background: #111111;
  color: #ffffff !important;
  border-radius: 10px;
  font-weight: 600;
  font-size: 1rem;
  text-decoration: none;
  transition: background 0.3s ease, transform 0.3s ease;
}
.view-vendors-btn:hover {
  background: #333333;
  transform: translateY(-2px);
}
/* Products */
.products-section {
  text-align: center;
}
.product-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  margin-bottom: 45px;
}
.product-tab {
  padding: 10px 26px;
  border-radius: 999px;
  border: 1px solid transparent;
  background: #f0f0f0;
  color: #333;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s ease, color 0.3s ease, transform 0.3s ease;
}
.product-tab:hover {
  transform: translateY(-2px);
}
.product-tab.active {
  background: #111111;
  color: #ffffff;
  border-color: #111111;
}
.category-grid :deep(.product-card-category) {
  border-radius: 18px;
  overflow: hidden;
}
.category-grid :deep(.productb-row) {
  gap: 0;
}
.category-grid :deep(.row.row-cols-2) {
  padding-left: 20px;
  padding-right: 0;
}
.category-grid :deep(.prodcard-padding) {
  padding: 12px;
}
.category-grid :deep(.col-6) {
  padding: 12px !important;
}
.category-grid :deep(.col-6:nth-child(3)),
.category-grid :deep(.col-6:nth-child(4)) {
  margin-top: 0 !important;
}
/* Contact */
.contact-section {
  margin-bottom: 120px;
}
/* Brands */
.brands-section {
  width: 100%;
  margin-bottom: 0;
  padding-bottom: 0;
}
.brands-section :deep(.section) {
  margin: 0;
}
.brands-section :deep(.container) {
  border-radius: 0;
}
/* Library search */
.library-search {
  background: #f5f5f5;
  padding: 70px 0;
}
.library-search-inner {
  width: min(900px, 92vw);
  margin: 0 auto;
  text-align: center;
}
.library-title {
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 24px;
  color: #111111;
}
.library-form {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: center;
}
.library-input {
  flex: 1 1 320px;
  max-width: 480px;
  padding: 14px 22px;
  border-radius: 999px;
  border: 1px solid #d8d8d8;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}
.library-input:focus {
  border-color: #111111;
  box-shadow: 0 0 0 4px rgba(17, 17, 17, 0.12);
}
.library-button {
  padding: 14px 34px;
  border-radius: 999px;
  border: none;
  background: #111111;
  color: #ffffff;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.3s ease;
}
.library-button:hover {
  background: #333333;
  transform: translateY(-2px);
}
/* Responsive */
@media (max-width: 1200px) {
  .vendors-grid {
    grid-auto-rows: minmax(200px, auto);
  }
}
@media (max-width: 992px) {
  .hero-inner {
    flex-direction: column;
    align-items: flex-start;
    padding-bottom: clamp(2.5rem, 8vw, 4rem);
  }
  .hero-cta {
    text-align: left;
  }
  .features-section {
    margin-top: -40px;
    margin-bottom: 80px;
  }
  .features-card :deep(.feature) {
    border-right: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    justify-content: flex-start;
  }
  .features-card :deep(.row > div:last-child .feature) {
    border-bottom: none;
  }
  .vendors-grid {
    grid-template-columns: 1fr;
    grid-template-areas:
      "v1"
      "v2"
      "v3"
      "v4";
    grid-auto-rows: minmax(240px, auto);
    gap: 16px;
  }
  .vendor-item {
    min-height: 260px;
  }
  .vendor-2,
  .vendor-3 {
    min-height: 340px;
  }
}
@media (max-width: 768px) {
  .hero-section {
    min-height: 520px;
  }
  .carousel-btn {
    width: 42px;
    height: 42px;
    font-size: 1rem;
    top: auto;
    bottom: 24px;
    transform: none;
  }
  .carousel-btn:hover {
    transform: scale(1.05);
  }
  .prev-btn {
    left: 24px;
  }
  .next-btn {
    right: 24px;
  }
  .vendor-item {
    border-radius: 16px;
    min-height: 240px;
  }
  .vendor-2,
  .vendor-3 {
    min-height: 340px;
  }
  .product-tabs {
    justify-content: flex-start;
  }
  .library-form {
    flex-direction: column;
  }
  .library-input,
  .library-button {
    width: 100%;
  }
}
@media (max-width: 576px) {
  .hero-text h1 {
    font-size: clamp(2.2rem, 8vw, 2.8rem);
  }
  .hero-link {
    font-size: 1.05rem;
  }
  .features-card {
    padding: 1.5rem;
    border-radius: 22px;
  }
  .features-card :deep(.feature) {
    padding: 16px 10px;
    flex-direction: column;
    text-align: center;
  }
  .vendor-name {
    font-size: 1.2rem;
  }
  .home-section {
    margin-bottom: 80px;
  }
  .library-search {
    padding: 50px 0;
  }
}
</style>
